module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 38.254 38.254",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }